module.exports = __webpack_public_path__ + "img/reception.e458ecc1.svg";